import { useLockPositions, type LockedPositionStore } from "@/hooks";
import { useMemo } from "react";
import { createColumnHelper, type RowData } from "@tanstack/react-table";
import { usePortfolioPositionsTable } from "../usePortfolioPositionsTable";

const filterPositionsWithBalanceAndRewards = (positions: LockedPositionStore[]) => {
    const filtered = positions.filter(({ lockedBalance, rewardsEarned, iUSDBalance, liUSDBalance }) => {
        if (+lockedBalance > 0 || +rewardsEarned > 0 || +iUSDBalance > 0 || +liUSDBalance > 0) {
            return true;
        }
        return false;
    });
    return filtered;
};

const lockedColumnHelper = createColumnHelper<LockedPositionStore>();

export const useLockedPositionsTable = () => {
    const { lockedPositions, isLoading } = useLockPositions();

    const positionsToDisplay = useMemo(() => {
        if (!lockedPositions?.length) {
            return [] as LockedPositionStore[];
        }
        return filterPositionsWithBalanceAndRewards(lockedPositions);
    }, [lockedPositions]);

    const lockedColumns = useMemo(
        () => [
            lockedColumnHelper.display({ id: "duration", header: "Duration", meta: { widthClass: "w-[10%]" } }),
            lockedColumnHelper.display({ id: "principal", header: "Principal", meta: { widthClass: "w-[30%]" } }),
            lockedColumnHelper.display({
                id: "interest",
                header: "Interest earned",
                meta: { widthClass: "w-[30%]" },
            }),
            lockedColumnHelper.display({ id: "apy", header: "APY", meta: { widthClass: "w-[20%]" } }),
            lockedColumnHelper.display({ id: "actions", header: "Actions", meta: { widthClass: "w-[10%]" } }),
        ],
        [],
    );

    return usePortfolioPositionsTable({
        data: positionsToDisplay,
        columns: lockedColumns,
        isLoading,
    });
};

declare module "@tanstack/react-table" {
    interface ColumnMeta<TData extends RowData, TValue> {
        widthClass?: string;
    }
}
